import { render, staticRenderFns } from "./Yunying.vue?vue&type=template&id=a4f10b66&scoped=true"
import script from "./Yunying.vue?vue&type=script&lang=js"
export * from "./Yunying.vue?vue&type=script&lang=js"
import style0 from "./Yunying.vue?vue&type=style&index=0&id=a4f10b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f10b66",
  null
  
)

export default component.exports